<template>
  <div class="other-bg" :style="{ backgroundImage: 'url(' + BG + ')' }">
    <div class="container-cm">
      <div class="sidemap">
        <a href="#U" title="中央內容區塊" id="AU" accesskey="U" name="U">:::</a>
        <a href="/Sitemap" title="網站導覽">網站導覽</a>
      </div>
    </div>
    <div class="container-cm">
      <h1 class="logo">
        <a href="/" title="農科院農業課程報名及查詢系統:回首頁">
          <img
            src="../assets/images/LOGO.png"
            alt="農科院農業課程報名及查詢系統:回首頁"
          />
        </a>
      </h1>
      <main class="training-content">
        <h2 class="training-h2-ie">個人資料提供同意書</h2>
        <div class="table-line"></div>
        <div class="training-detail-container">
          <div class="training-detail-content">
            <a href="#C" title="中央內容區塊" id="AC" accesskey="C" name="C"
              >:::</a
            >
            <p class="sidemap_p block">
              財團法人農業科技研究院(以下簡稱本院)依據個人資料保護法（以下簡稱個資法）第八條第一項規定，向台端義務告知下列事項，請台端詳閱：
            </p>
            <p class="sidemap_p bold">一、蒐集之目的：</p>
            <ul class="sidemap_p p-x">
              <li>
                （一）從事農業科技之研究、開發及提供相關服務、諮詢、驗證及檢驗等工作。
              </li>
              <li>
                （二）本院創新育成、產學研發、智慧財產管理、技術移轉、業界服務、教育訓練及推廣等業務。
              </li>
              <li>（三）其他基於法人許可登記目的或本院捐助章程明訂之業務。</li>
            </ul>
            <p class="sidemap_p bold">二、蒐集之個人資料類別：</p>
            <p class="sidemap_p block">
              如姓名、身分證統一編號、聯絡方式等，詳如本院相關業務申請書、契約書或報名表等內容。
            </p>
            <p class="sidemap_p bold">
              三、個人資料利用之期間、地區、對象及方式：
            </p>
            <ul class="sidemap_p p-x">
              <li>
                （一）期間：1.個人資料蒐集之特定目的存續期間；
                  2.依相關法令規定或契約約定之保存年限；
                  3.本院因執行業務所必須之保存期間。
              <li>
                （二）地區：本院所在地、本院業務委外機構所在地、與本院有業務往來之機關/構所在地。
              </li>
              <li>
                （三）對象：本院所轄各所、處、中心、組、課等單位、其他與本院有業務往來之機關/構、依法
                有調查權機關或監理機關。
              </li>
              <li>（四）方式：利用自動化機器或其他非自動化之方式。</li>
            </ul>
            <p class="sidemap_p bold">
              四、依據個資法第三條規定，台端就本院保有台端之個人資料得行使下列權利：
            </p>
            <ul class="sidemap_p p-x">
              <li>
                （一）得向本院查詢、請求閱覽或請求製給複製本，而本院依法得酌收必要成本費用。
              </li>
              <li>
                （二）得向本院請求補充或更正，惟依法台端應為適當之釋明。
              </li>
              <li>
                （三）得向本院請求停止蒐集、處理、利用或刪除，惟依法本院因執行業務所必須者，得不依台端請求為之。
              </li>
              <li>（四）得隨時透過本院提供之聯絡管道（電洽本院個資保護聯絡專線(03)518-5061、書面郵寄或親洽等）要求停止利用相關個人資料。本院於接獲台端通知經確認台端身分後立即受理，並通知相關業務所屬部門辦理。</li>
            </ul>
            <p class="sidemap_p bold">
              五、依據個資法第三條規定，台端就本院保有台端之個人資料得行使下列權利：
            </p>
            <p class="sidemap_p block">
              台端得自由選擇是否提供相關個人資料，若台端拒絕提供該等資料，本院將無法進行必要之審核及處理作業，因此而無法提供台端相關服務。
            </p>
            <hr>
            <p class="sidemap_p">
              經 貴院向受告知人（以下簡稱本人）告知上開事項，本人已清楚瞭解 貴院蒐集、處理或利用本人個人資料之目的及用途，並同意貴院在上述蒐集目的內蒐集、處理或利用本人之個人資料。
            </p>
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import BG from '../assets/images/content_BG01.jpg';

export default {
  name: 'privacy',
  components: {
    Footer,
  },
  data() {
    return {
      BG,
    };
  },
  methods: {},
  created() {},
  mounted() {},
  filters: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.sidemap_p {
  font-size: 1.2rem;
  line-height: 2;
}

.block {
  text-indent: 2rem;
}

.bold {
  font-weight: bold;
}

.p-x {
  padding: 1rem;
}
.other-bg {
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
}

.training-content {
  padding: 0 4rem 300px 4rem;
  @media (max-width: 1024px) {
    padding: 0 0 300px 0;
  }
}

.training-h2 {
  background: linear-gradient(to bottom, #a0c8c0 0, #5aa3a8 100%);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 10px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.training-h2-ie {
  color: #5aa3a8;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 10px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.training-h3 {
  font-size: 1.5rem;
  text-align-last: left;
}

.table-line {
  height: 1px;
  background-color: #edf1f1;
  width: 100%;
}

#AC,
#AU {
  color: transparent;
}

.training-detail-container {
  padding: 0.6rem 5rem;
  @media (max-width: 1024px) {
    padding: 0.6rem 0;
  }
}

.training-detail-content {
  background-color: #fff;
  border-radius: 1rem;
  padding: 4.5rem 5rem 4.5rem 9rem;
  box-shadow: 0 0 3px 3px rgba(227, 232, 232, 0.5);
  @media (max-width: 1024px) {
    padding: 1.5rem;
  }
  .list {
    display: flex;
    font-size: 1.1rem;
    color: #3e3e3f;
    letter-spacing: 1.5px;
    line-height: 2;
    @media (max-width: 420px) {
      flex-direction: column;
      margin-bottom: 2rem;
    }
    .title {
      min-width: 100px;
      display: inline-block;
      text-align: right;
      margin-right: 30px;
      @media (max-width: 420px) {
        text-align: left;
      }
    }
    .content {
      width: 100%;
      display: inline-block;
    }
  }
  .btn-box {
    display: flex;
    justify-content: flex-end;
    padding-top: 5.5rem;
    @media (max-width: 767px) {
      flex-direction: column;
      align-items: center;
    }

    a:first-child {
      margin-right: 1.5rem;

      @media (max-width: 767px) {
        margin-right: 0;
        margin-bottom: 1.5rem;
      }
    }
  }
  .btn {
    display: block;
    color: #fff;
    border-radius: 5rem;
    padding: 0.5rem 0;
    width: 120px;
    font-size: 1.5rem;
    letter-spacing: 5px;
    text-decoration: none;
    text-align: center;

    &.light-green {
      background-color: #4dba95;
    }

    &.dark-green {
      background-color: #8bb75f;
    }
  }
}
</style>

<style lang="scss">
.pop-check {
  text-align: center;
  font-size: 1.5rem;
  color: #f98d28;
  padding: 10px 0;
  input[type="checkbox"] {
    border: 2px solid #f98d28;
    width: 16px;
    height: 16px;
  }
}

// sweetalert 客製
.swal2-content {
  padding: 0 1rem;

  p {
    text-align-last: left;
    font-size: 1.1rem;
  }
}

.swal2-styled.swal2-confirm,
.swal2-styled.swal2-cancel {
  font-size: 1.5rem;
  border-radius: 5rem;
  font-weight: bold;
  padding: 10px 55px;
}

.swal2-styled:focus {
  outline: 3px dashed #5da3ab;
}
</style>
